import { useDispatch, useSelector } from "react-redux";
import Loader from "../../common/loader/Loader";
import TableDesign from "../../common/table/TableDesign";
import { Button, Col, Form, Row } from "react-bootstrap";
import { useEffect, useState } from "react";
import AlertModal from "./AlertModal";
import useAlertModal from "./useAlertModal";
import AddEditReportTimeModal from "./AddEditReportTimeModal";
import {
  AddReportTime,
  EditReportTime,
} from "../../../store/actions/dashboardsAction";
import ApiResponsePopup from "../../common/modal/ApiResponsePopup";
import { getProfile } from "../../../store/actions/adminAction";
import { resetPopup } from "../../../store/reducerSlice/dashboards";
import ToggelActivatatePopup from "./ToggelActivatatePopup";
import DeleteTimePopup from "./DeleteTimePopup";
import moment from "moment";
import ReportTimeForm from "./ReportTimeForm";
import ToggleSwitch from "../../common/ToggleSwitch";

const MainReport = () => {
  const daysOfWeek = [
    { label: "Monday", value: 1 },
    { label: "Tuesday", value: 2 },
    { label: "Wednesday", value: 3 },
    { label: "Thursday", value: 4 },
    { label: "Friday", value: 5 },
    { label: "Saturday", value: 6 },
    { label: "Sunday", value: 0 },
  ];

  const dispatch = useDispatch();
  const { adminDetail } = useSelector((state) => state.admin);
  const tableHeadings = [
    { label: "S. No." },
    { label: "Frequency" },
    { label: "Week Days" },
    { label: "Time" },
    { label: "Next Report", align: "text-center" },
    { label: "Status", align: "text-center" },
    ...(adminDetail?.isAdmin
      ? [{ label: "Action", align: "text-center" }]
      : []),
  ];
  const {
    isLoader,
    isRecordUpdated,
    error: apiError,
  } = useSelector((state) => state.dashboards);
  // current date (formatted as YYYY-MM-DD)
  const today = moment().format("YYYY-MM-DD");

  const [filter, setFilter] = useState({
    frequency: "",
    weekDays: "",
    date: today,
    time: "",
  });

  const [showModal, setShowModal] = useState(false);
  const [isShow, setIsShow] = useState(false);
  const [editingIndex, setEditingIndex] = useState(null);
  const [editingData, setEditingData] = useState(null);

  const [message, setMessage] = useState(null);
  const [title, setTitle] = useState(null);
  const [showResult, setShowResult] = useState(false);
  const [deleteRec, setDeleteRec] = useState(null);
  const [deleteModalShow, setDeleteModalShow] = useState(false);
  const [toggleActivateRec, setToggleActivateRec] = useState(null);
  const [toggleActivateStatus, setToggleActivateStatus] = useState(null);
  const [toggleActivateModalShow, setToggleActivateModalShow] = useState(false);

  // Handle remove report time
  const handleRemoveTime = (index) => {
    console.log("index to delete:", index);
    dispatch(resetPopup());
    setDeleteRec(index?._id);
    setDeleteModalShow(true);
    setTitle("Delete Time");
    setMessage("Time deleted successfully!");
  };

  // Handle edit report time
  const handleEditTime = (index) => {
    const timeToEdit = adminDetail?.times?.[index];
    console.log("timeToEdit:", timeToEdit);
    if (timeToEdit) {
      setEditingIndex(index);
      setEditingData(timeToEdit);
      setShowModal(true);
    }
  };

  // Handle add report
  const handleAddReport = () => {
    setEditingIndex(null);
    setEditingData(null);
    setShowModal(true);
  };

  // Handle save report times from modal
  const handleSaveReportTimes = (timesData, editIndex) => {
    console.log("Saving report times:", timesData);
    console.log("Edit index:", editIndex);
    const reportTime = timesData[0];
    console.log("called API");
    if (reportTime?._id) {
      // Edit existing time
      const payload = {
        // times: [
        // {
        timeId: reportTime._id, // map _id to TimeId
        hour: reportTime.hour,
        minute: reportTime.minute,
        recur: reportTime.recur,
        // isActive: reportTime.isActive,
        // },
        // ],
      };
      // showSuccess("Report time updated successfully!");
      dispatch(EditReportTime(payload)).then(({ payload }) => {
        console.log("payload", payload);
        if (payload?.success) {
          // re-fetch server list
          // setIsUploading(true);
          setIsShow(true);
          // setShow(false);
          setEditingIndex(null);
          // setModalTimes([defaultModalItem()]);
        } else {
          // show popup (kept same behavior as your original code)
          setIsShow(true);
        }
      });
    } else {
      // Add new times
      console.log("Adding new report times:", timesData);
      const reportTime = timesData[0];
      if (reportTime) {
        // Edit existing time
        const payload = {
          // times: [
          // {// map _id to TimeId
          hour: reportTime.hour,
          minute: reportTime.minute,
          recur: reportTime.recur,
          // isActive: reportTime.isActive,
          // },
          // ],
        };
        dispatch(AddReportTime(payload)).then(({ payload }) => {
          if (payload?.success) {
            // re-fetch server list
            setIsShow(true);
            setEditingIndex(null);
          } else {
            // show popup (kept same behavior as your original code)
            setIsShow(true);
          }
        });
      }
    }
  };

  // Handle close modal
  const handleCloseModal = () => {
    setShowModal(false);
    setEditingIndex(null);
    setEditingData(null);
  };

  useEffect(() => {
    if (isRecordUpdated) {
      dispatch(getProfile());
    }
  }, [isRecordUpdated]);

  const hideHandlerRes = () => setIsShow(false);

  const hideHandle = () => {
    dispatch(resetPopup());
    setTitle(null);
    setMessage(null);
    setShowResult(false);
    // setIsShow(false);
    setDeleteModalShow(false);
    setToggleActivateModalShow(false);
  };

  const getNextReportDate = (item) => {
    const now = new Date();
    const { hour, minute, recur } = item;
    const { freq, interval, byDay, byMonthDay } = recur;

    let next = new Date();
    next.setHours(Number(hour), Number(minute), 0, 0);

    // DAILY / BIWEEKLY treated as daily with interval (1 or 2)
    if (freq === "DAILY") {
      if (next <= now) next.setDate(next.getDate() + interval);
    }

    // WEEKLY / BIWEEKLY
    else if (freq === "WEEKLY") {
      const today = next.getDay(); // 0-6
      let minDiff = Infinity;

      byDay.forEach((day) => {
        let diff = day - today;
        if (diff < 0) diff += 7;

        if (diff === 0 && next <= now) diff = 7;

        if (diff < minDiff) minDiff = diff;
      });

      next.setDate(next.getDate() + minDiff + 7 * (interval - 1));
    }

    // MONTHLY / QUARTERLY
    else if (freq === "MONTHLY") {
      const monthDay = byMonthDay?.[0];
      if (monthDay) {
        next.setDate(monthDay);
        if (next <= now) {
          next.setMonth(next.getMonth() + interval);
          next.setDate(monthDay);
        }
      }
    }

    return {
      nextDate: moment(next).format("YYYY-MM-DD"),
      nextDay: moment(next).format("dddd"),
    };
  };

  return (
    <>
      {isLoader && <Loader />}

      <DeleteTimePopup
        onHide={hideHandle}
        deleteRec={deleteRec}
        deleteModalShow={deleteModalShow}
        setDeleteModalShow={setDeleteModalShow}
      />
      <ToggelActivatatePopup
        onHide={hideHandle}
        toggleActivateRec={toggleActivateRec}
        toggleActivateStatus={toggleActivateStatus}
        toggleActivateModalShow={toggleActivateModalShow}
        setToggleActivateModalShow={setToggleActivateModalShow}
      />

      {/* Add/Edit Report Time Modal */}
      <AddEditReportTimeModal
        show={showModal}
        onHide={handleCloseModal}
        editingIndex={editingIndex}
        initialData={editingData}
        onSave={handleSaveReportTimes}
      />
      <div className="w-100 mt-4">
        {/* 🔹 Filter Section */}
        {adminDetail?.isAdmin && (
          <h5 className="fw-bold">Manage Auto Reports</h5>
        )}
        {adminDetail?.isAdmin && (
          <ReportTimeForm onSave={handleSaveReportTimes} />
        )}

        {/* 🔹 Add Button */}
        <div className="d-flex justify-content-between align-items-center mt-2 mb-2">
          <h5 className="fw-bold">Scheduled Reports</h5>
          {/* <Button variant="success" size="sm" onClick={handleAddReport}>
            + Add Time
          </Button> */}
        </div>
        <TableDesign className="mt-5 pt-4" {...{ title: "", tableHeadings }}>
          {adminDetail?.times?.length > 0 ? (
            adminDetail.times.map((time, index) => (
              <tr key={index}>
                <td align="left">{index + 1}</td>

                <td>
                  {time?.recur?.freq === "MONTHLY" &&
                  time?.recur?.interval === 3
                    ? "QUARTERLY"
                    : time?.recur?.freq || "--"}
                </td>
                <td>
                  {time?.recur?.byDay?.length > 0
                    ? time.recur.byDay
                        .map((day) =>
                          daysOfWeek
                            .find((d) => d.value === day)
                            ?.label?.slice(0, 3)
                        )
                        .join(", ")
                    : time?.recur?.byMonthDay?.length > 0
                    ? time?.recur?.byMonthDay[0]
                    : "--"}
                </td>
                <td align="left">{`${time.hour || "00"}:${
                  time.minute || "00"
                }`}</td>
                <td align="center">
                  {(() => {
                    const next = getNextReportDate(time);
                    return `${next.nextDate} (${next.nextDay})`;
                  })()}
                </td>
                <td align="left">
                  <ToggleSwitch
                    checked={time?.isActive}
                    disabled={!adminDetail?.isAdmin} // Disable only if user is NOT admin
                    onChange={() => {
                      if (adminDetail?.isAdmin) {
                        // Open confirmation modal
                        setToggleActivateRec(time?._id);
                        setToggleActivateStatus(time?.isActive);
                        setToggleActivateModalShow(true);
                        setTitle("Change Auto Report Status");
                        setMessage(
                          time?.isActive
                            ? "Are you sure you want to deactivate this auto report?"
                            : "Are you sure you want to activate this auto report?"
                        );
                      }
                    }}
                  />
                  {/* {time?.isActive ? "Active" : "Inactive"} */}
                </td>
                {adminDetail?.isAdmin && (
                  <td align="center">
                    <Button
                      variant="outline-success"
                      size="sm"
                      onClick={() => handleEditTime(index)}
                    >
                      Edit
                    </Button>
                    <Button
                      variant="outline-danger"
                      size="sm"
                      className="ms-2"
                      onClick={() => handleRemoveTime(time)}
                    >
                      Remove
                    </Button>
                  </td>
                )}
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="5" align="center">
                No Report Times Added
              </td>
            </tr>
          )}
        </TableDesign>
      </div>
      {isShow && (
        <ApiResponsePopup
          {...{
            hideHandlerRes,
            isRecordAdded: isShow,
            title: "Report Time",
            successMsg: "Report time updated successfully.",
            errorRes: apiError?.message,
          }}
        />
      )}
    </>
  );
};

export default MainReport;
